import type { SanityPageSection } from '#/lib/sanity/queries/sections';
import type { PageLayoutSharedProps } from '#/lib/types';

import { PageSection } from './PageSection';

type Props = PageLayoutSharedProps & {
  sections?: SanityPageSection[];
  sectionIndex?: number | null;
};

export function PageSections({
  sections,
  sectionIndex,
  initialData,
  isPreview,
  sanitySource,
}: Props) {
  if (!sections || sections.length === 0) return null;

  const sectionIndexWithDefault = sectionIndex ?? 0;
  return (
    <>
      {sections.map((section, index) => {
        return (
          <PageSection
            isPreview={isPreview}
            key={section._key}
            section={section}
            index={sectionIndexWithDefault + index}
            initialData={initialData}
            sanitySource={sanitySource}
          />
        );
      })}
    </>
  );
}
